import * as React from 'react'

import { Box, Skeleton } from '@factorialco/deprecated-design-system'

export const JobApplicationOtherInfoSkeleton = () => {
  return (
    <Box gap="s40">
      <Box gap="s40">
        <Skeleton height="s24" width="s140" />
        {[...Array(4)].map((_, index) => (
          <Box component="li" alignItems="center" gap="s40" flexDirection="row" key={index}>
            <Skeleton height="s16" width="s80" />
            <Skeleton height="s16" width="s200" />
          </Box>
        ))}
      </Box>

      <Box gap="s24">
        <Skeleton height="s24" width="s140" />
        <Box component="li" gap="s12" flexDirection="row" alignItems="center">
          <Skeleton height="s24" width="s96" />
          <Skeleton height="s24" width="s140" />
        </Box>
      </Box>
    </Box>
  )
}
